import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloatButton from "./WhatsAppFloatButton";

import { StoreSettings, ExclusiveProduct } from "../types";

interface MainLayoutProps {
  children: React.ReactNode;
  store_settings: StoreSettings;
  exclusiveProducts: ExclusiveProduct[];
  cart?: { items_count: number };
}

const MainLayout = ({ children, store_settings, exclusiveProducts, cart }: MainLayoutProps) => {
  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col">
      <Header
        storeName={store_settings?.store_name}
        storeLogo={store_settings?.store_logo}
        storeSettings={store_settings}
        exclusiveProducts={exclusiveProducts}
        cart={cart}
      />
      <main className="flex-grow">{children}</main>
      <Footer store_settings={store_settings} />
      <WhatsAppFloatButton store_settings={store_settings} />
    </div>
  );
};

export default MainLayout;
